export const rolePermissions = {
  listMasterData: 'ListMasterData',
  createMasterData: 'CreateMasterData',
  updateMasterData: 'UpdateMasterData',
  removeMasterData: 'RemoveMasterData',
  downloadMasterData: 'DownloadMasterData',
  listUsersAndRoles: 'ListAuthentication',
  createUsersAndRoles: 'CreateAuthentication',
  updateUsersAndRoles: 'UpdateAuthentication',
  removeUsersAndRoles: 'RemoveAuthentication',
  downloadUsersAndRoles: 'DownloadAuthentication',
  listMatchingAndScheduling: 'ListMatchingandScheduling',
  downloadMatchingAndScheduling: 'DownloadMatchingandScheduling',
  listNomination: 'ListNomination',
  uploadNomination: 'UploadNomination',
  downloadNomination: 'DownloadNomination',
  listNominationHistory: 'ListNominationHistory',
  downloadNominationHistory: 'DownloadNominationHistory',
  listTradeMatchingStatus: 'ListTradeandMatching',
  downloadTradeAndMatching: 'DownloadTradeandMatching',
  listRejectedNomination: 'ListRejectedNomination',
  listTrading: 'ListTrading',
  updateTrading: 'UpdateTrading',
  removeTrading: 'RemoveTrading',
  downloadTrading: 'DownloadTrading',
  listNBPTrade: 'ListNBPTrade',
  downloadNBPTrade: 'DownloadNBPTrade',
  listBeachSwingAndTrades: 'ListBeachSwingAndTrade',
  downloadBeachSwingAndTrades: 'DownloadBeachSwingAndTrade',
  listAudit: 'ListAudit',
  listSwingNominationsByContract: 'ListSwingNominationsByContract',
  updateSwingNominationsByContract: 'UpdateSwingNominationsByContract',
  downloadSwingNominationsByContract: 'DownloadSwingNominationsByContract',
  deleteSwingNominationsByContract: 'DeleteSwingNominationsByContract',
  listShipperActualDeliveries: 'ListShipper',
  updateShipperActualDeliveries: 'UpdateShipper',
  downloadShipperActualDeliveries: 'DownloadShipper',
  listProducerDeliveries: 'ListProducer',
  downloadProducerDeliveries: 'DownloadProducer',
  listCva: 'ListCva',
  downloadCvaXml: 'DownloadCvaXml',
  uploadCvaXml: 'UploadCvaXml',
  listM2Report: 'ListM2Report',
  downloadM2Report: 'DownloadM2Report',
  uploadM2Report: 'UploadM2Report',
  listCounterpartyStatements: 'ListCounterpartyStatement',
  downloadCounterpartyStatements: 'DownloadCounterpartyStatement',
  uploadCounterpartyStatements: 'UploadCounterpartyStatement',
  listBeachPosition: 'ListBeachPosition',
  listCvaDashboard: 'ListCvaDashboard',
  updateCvaDashboard: 'UpdateCvaDashboard',
};

export const MESSAGE = {
  unAuthorized: 'Sorry you are not authorized to access this page',
};
